import { render, staticRenderFns } from "./Renovaciones.vue?vue&type=template&id=bd4a033a&scoped=true&"
import script from "./Renovaciones.vue?vue&type=script&lang=js&"
export * from "./Renovaciones.vue?vue&type=script&lang=js&"
import style0 from "./Renovaciones.vue?vue&type=style&index=0&id=bd4a033a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4a033a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
